import { get, post } from "../../api";
import url from "../../api/apisList";
import * as types from "./actionTypes";
import Key from "../../clientVariables.json";

let jobDetailsAbortController = null;
let jobDetailsInFlightId = null;

export const alertSnackBarAction = (alertMessage, alertStatus) => {
  return async (dispatch) => {
    dispatch({
      type: types.ALERT_SNACK_BAR_ACTION,
      alertMessage,
      alertStatus,
    });
  };
};

export const closeSnackBarAction = () => {
  return async (dispatch) => {
    dispatch({
      type: types.CLOSE_SNACK_BAR_ACTION,
    });
  };
};

// export const saveUserDataAction = (userCredentials) => {
//   let apiUrl = url("login");

//   return async (dispatch) => {
//     try {
//       const res = await post(apiUrl, userCredentials);
//       let user;

//       if (res?.success === 1) {
//         user = res?.data?.user;
//         dispatch({
//           type: types.SAVE_USER_ACTION,
//           payload: user,
//         });
//         //await  dispatch(vmailSignIUpAction(user))
//         await dispatch(vmailSignInAction(user?.username, "Welcome@123", user));
//       } else {
//         let msg = res?.data;
//         dispatch(alertSnackBarAction(msg, "warning"));
//       }
//       return res?.data;
//     } catch (err) {
//       dispatch({
//         type: types.SAVE_USER_ACTION_FAIL,
//         payload: err,
//       });
//       return "login_failed";
//     }
//   };
// };

export const saveUserDataAction = (userCredentials, userRole) => {
  const apiUrl = url("login");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, userCredentials);
      let user;
      if (res?.success === 1) {
        user = res?.data?.user;
        //console.log("User after login:", user);
        dispatch({
          type: types.SAVE_USER_ACTION,
          payload: user,
        });
        if (user?.usertype == 3 || user?.usertype == 13) {
          await dispatch(
            vmailSignInAction(user?.username, "Welcome@123", user)
          );
        }
      } else {
        let msg = res?.data;
        dispatch(alertSnackBarAction(msg, "warning"));
      }

      // dispatch({
      //   type: types.SAVE_USER_ACTION,
      //   payload: user,
      // });

      return res?.data;
    } catch (err) {
      dispatch({
        type: types.SAVE_USER_ACTION_FAIL,
        payload: err,
      });
      return "login_failed";
    }
  };
};

export const resumeParser = (file) => {
  let apiUrl = url("resume_parser_ai");

  var resumeFile = {
    resume: file,
  };
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, resumeFile);
      let response;

      if (res?.data) {
        response = res?.data;
      }

      dispatch({
        type: types.RESUME_PARSER_ACTION,
        payload: response,
      });
    } catch (err) {
      dispatch({
        type: types.RESUME_PARSER_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const resetAction = () => {
  return async (dispatch) => {
    dispatch({
      type: types.RESET_ACTION,
    });
  };
};

export const resetCandidatesAction = () => {
  return async (dispatch) => {
    dispatch({
      type: types.RESET_CANDIDATES_ACTION,
    });
  };
};

export const getCandidatesAction = (userid, page, limit) => {
  let apiUrl = url("candidates")(userid, page, limit);

  return async (dispatch) => {
    try {
      const res = await get(apiUrl);
      let candidates;

      if (res?.data) {
        candidates = res?.data?.candidates;
      }

      if (candidates.length > 0) {
        dispatch({
          type: types.GET_CANDIDATES_ACTION,
          payload: candidates,
        });
      }
      return res;
    } catch (err) {
      dispatch({
        type: types.GET_CANDIDATES_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const getCandidatesSearchAction = (userid, page, limit, searchText) => {
  let apiUrl = url("candidates_search")(userid, page, limit, searchText);

  return async (dispatch) => {
    try {
      dispatch({
        type: types.GET_CANDIDATES_SEARCH_ACTION,
      });
      const res = await get(apiUrl);
      let candidates;

      if (res?.data) {
        candidates = res?.data?.candidates;
      }

      if (candidates.length > 0) {
        dispatch({
          type: types.GET_CANDIDATES_SEARCH_ACTION_SUCCESS,
          payload: candidates,
        });
      }
    } catch (err) {
      dispatch({
        type: types.GET_CANDIDATES_SEARCH_ACTION_FAIL,
        payload: err,
      });
    }
  };
};
export const selectedCandidateAction = (candidate) => (dispatch) => {
  console.log("selected Candidate Action", candidate);
  dispatch({
    type: types.SELECTED_CANDIDATE_ACTION,
    payload: candidate,
  });
};

const candidateDetailInFlight = {};

export const getCandidateDetailAction = (candidateID, options = {}) => {
  const { force = false } = options;
  let apiUrl = url("candidate")(candidateID);

  return async (dispatch, getState) => {
    if (!candidateID) return null;
    console.log("DETAIL REQUEST START", candidateID);

    const existing = getState()?.appManagement?.candidateDetails;
    if (
      !force &&
      existing?.candidate_id != null &&
      String(existing.candidate_id) === String(candidateID)
    ) {
      return {
        candidate: existing,
        interest_count: getState()?.appManagement?.interested_jobs_daycount,
        jobs_count: getState()?.appManagement?.jobs_daycount,
      };
    }

    if (!force && candidateDetailInFlight[candidateID]) {
      return candidateDetailInFlight[candidateID];
    }

    const request = (async () => {
      dispatch({ type: types.GET_CANDIDATE_DETAIL_LOADING_ACTION });
      try {
        const res = await get(apiUrl);
        console.log(
          "DETAIL RESPONSE",
          candidateID,
          res?.data?.candidate?.candidate_id,
          res?.data?.candidate?.user_id
        );
        let candidate;
        let interested_jobs_daycount;
        let jobs_daycount;

        if (res?.data) {
          candidate = res?.data?.candidate;
          interested_jobs_daycount = res?.data?.interest_count;
          jobs_daycount = res?.data?.jobs_count;
        }

        dispatch({
          type: types.GET_CANDIDATE_DETAIL_ACTION,
          payload: candidate,
          interested_jobs_daycount: interested_jobs_daycount,
          jobs_daycount: jobs_daycount,
        });
        dispatch(removeJobtypeFilter());
        return res.data;
      } catch (err) {
        dispatch({
          type: types.GET_CANDIDATE_DETAIL_ACTION_FAIL,
          payload: err,
        });
      } finally {
        delete candidateDetailInFlight[candidateID];
      }
    })();

    candidateDetailInFlight[candidateID] = request;
    return request;
  };
};

export const getUserSubmissionsAction = (userid, page, limit) => {
  let apiUrl = url("user_submissions")(userid, page, limit);

  return async (dispatch) => {
    try {
      const res = await get(apiUrl);
      let userSubmissions;

      if (res?.data) {
        userSubmissions = res?.data?.submissions;
      }

      dispatch({
        type: types.GET_USER_SUBMISSIONS_ACTION,
        payload: userSubmissions,
      });
    } catch (err) {
      dispatch({
        type: types.GET_USER_SUBMISSIONS_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const getcandidateSubmissionsAction = (
  userid,
  candidateID,
  page,
  limit
) => {
  return async (dispatch) => {
    if (!userid || !candidateID) {
      dispatch({
        type: types.GET_CANDIDATE_SUBMISSIONS_ACTION,
        payload: [],
      });
      return;
    }

    let apiUrl = url("candidate_submissions")(userid, candidateID, page, limit);

    try {
      const res = await get(apiUrl);
      let candidateSubmissions = [];

      if (res?.data) {
        candidateSubmissions = res?.data?.submissions;
      }

      dispatch({
        type: types.GET_CANDIDATE_SUBMISSIONS_ACTION,
        payload: candidateSubmissions,
      });
    } catch (err) {
      dispatch({
        type: types.GET_CANDIDATE_SUBMISSIONS_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const getSolrJobsAction = (generatedQuery) => {
  //console.log("generatedQuery",generatedQuery)
  let apiUrl = url("solr_jobs");

  let body = {
    url: generatedQuery,
  };
  return async (dispatch) => {
    try {
      if (generatedQuery) {
        dispatch({
          type: types.GET_SOLR_JOBS_LOADING_ACTION,
        });
        const res = await post(apiUrl, body);
        let solrJobs;
        let solrJobsCount;

        if (res?.jobs) {
          solrJobs = res?.jobs;
          solrJobsCount = res?.count;
        }

        let solrResults = {
          solrJobs: solrJobs,
          solrJobsCount: solrJobsCount,
        };

        dispatch({
          type: types.GET_SOLR_JOBS_ACTION,
          payload: solrResults,
        });
        return res;
      } else {
        return [];
      }
    } catch (err) {
      dispatch({
        type: types.GET_SOLR_JOBS_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const getLatestSolrJobsAction = (generatedQuery) => {
  let apiUrl = url("solr_jobs");

  let body = {
    url: generatedQuery,
  };
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, body);
      let solrJobs;
      let solrJobsCount;

      if (res?.jobs) {
        solrJobs = res?.jobs;
        solrJobsCount = res?.count;
      }

      let solrResults = {
        latestSolrJobs: solrJobs,
        latestSolrJobsCount: solrJobsCount,
      };

      dispatch({
        type: types.GET_LATEST_SOLR_JOBS_ACTION,
        payload: solrResults,
      });
      // return res?.jobs;
    } catch (err) {
      dispatch({
        type: types.GET_LATEST_SOLR_JOBS_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const getSubmissionTypes = () => {
  let apiUrl = url("submission_types")();
  return async (dispatch) => {
    try {
      const response = await get(apiUrl);
      let submissionTypes;
      if (response?.data) {
        submissionTypes = response?.data?.types;
      }
      dispatch({
        type: types.GET_SUBMISSIONS_TYPES_ACTION,
        payload: submissionTypes,
      });
    } catch (err) {
      dispatch({
        type: types.GET_SUBMISSIONS_TYPES_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const getCandidateDocuments = (candidateID, userid, options = {}) => {
  const { clearFirst = true } = options;
  let apiUrl = url("candidate_documents")(candidateID, userid);
  return async (dispatch) => {
    try {
      if (clearFirst) {
        dispatch({
          type: types.GET_CANDIDATE_DOCUMENTS_ACTION,
          payload: [],
        });
      }

      let res = await get(apiUrl);
      let candidateDocuments;
      if (res?.data) {
        candidateDocuments = res?.data?.documents;
      }
      dispatch({
        type: types.GET_CANDIDATE_DOCUMENTS_ACTION,
        payload: candidateDocuments,
      });
    } catch (err) {
      dispatch({
        type: types.GET_CANDIDATE_DOCUMENTS_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const getJobDetailsAction = (jobId, options = {}) => {
  const { force = false } = options;
  const apiUrl = url("job_details")(jobId);
  return async (dispatch, getState) => {
    if (!jobId) {
      try {
        if (jobDetailsAbortController) {
          jobDetailsAbortController.abort();
        }
      } catch { }
      jobDetailsAbortController = null;
      jobDetailsInFlightId = null;
      dispatch({
        type: types.GET_JOB_DETAILS_ACTION,
        payload: {},
      });
      return;
    }

    const existing = getState()?.appManagement?.jobDetails;
    if (
      !force &&
      existing?.id != null &&
      String(existing.id) === String(jobId) &&
      Object.keys(existing).length > 0
    ) {
      dispatch({
        type: types.GET_JOB_DETAILS_ACTION,
        payload: existing,
      });
      return existing;
    }

    if (
      !force &&
      jobDetailsInFlightId != null &&
      String(jobDetailsInFlightId) === String(jobId)
    ) {
      return;
    }

    try {
      if (jobDetailsAbortController) {
        jobDetailsAbortController.abort();
      }
      const controller = new AbortController();
      jobDetailsAbortController = controller;
      jobDetailsInFlightId = jobId;
      const signal = controller.signal;

      dispatch({
        type: types.GET_JOB_DETAILS_REQUEST,
        meta: { requestId: jobId },
      });

      let response = await get(apiUrl, { signal });
      let jobDetails;

      if (response?.data) {
        jobDetails = response?.data?.job;

        dispatch({
          type: types.GET_JOB_DETAILS_ACTION,
          payload: jobDetails,
        });
      } else {
        dispatch({
          type: types.GET_JOB_DETAILS_ACTION_FAIL,
        });
      }
      if (jobDetailsAbortController?.signal === signal) {
        jobDetailsAbortController = null;
        jobDetailsInFlightId = null;
      }
    } catch (err) {
      const activeSignal = jobDetailsAbortController?.signal;
      if (err.name === "AbortError") {
        if (activeSignal && activeSignal.aborted) {
          jobDetailsAbortController = null;
          jobDetailsInFlightId = null;
        }
        return;
      }
      dispatch({
        type: types.GET_JOB_DETAILS_ACTION_FAIL,
      });
      if (activeSignal && activeSignal.aborted) {
        jobDetailsAbortController = null;
        jobDetailsInFlightId = null;
      }
    }
  };
};
export const openRightPanelAction = (status) => (dispatch) => {
  dispatch({
    type: types.OPEN_RIGHT_PANEL_ACTION,
    payload: status,
  });
};


export const selectedJobAction = (job) => (dispatch, getState) => {
  if (!job?.id) {
    dispatch({
      type: types.SELECTED_JOB_ACTION,
      payload: null,
    });
    return;
  }

  const currentSelectedId = getState()?.appManagement?.selectedJob?.id;
  if (
    currentSelectedId != null &&
    String(currentSelectedId) === String(job.id)
  ) {
    return;
  }

  dispatch({
    type: types.SELECTED_JOB_ACTION,
    payload: job,
  });
  dispatch(getJobDetailsAction(job.id));
};

export const getSubmissionsByJobAction = (userid, candidateID, jobId) => {
  let apiUrl = url("submissions_by_job")(userid, candidateID, jobId);
  return async (dispatch) => {
    try {
      let res = await get(apiUrl);
      let submissions;
      if (res?.data) {
        submissions = res?.data;
      }
      dispatch({
        type: types.GET_SUBMISSIONS_ACTION,
        payload: submissions,
      });
    } catch (err) {
      dispatch({
        type: types.GET_SUBMISSIONS_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const updateSubmissionsAction = (updatedData) => {
  let apiUrl = url("update_submissions");
  return async (dispatch) => {
    try {
      let res = await post(apiUrl, updatedData);
      if (res?.data?.submission?.affectedRows > 0) {
        let userid = updatedData?.userid;
        let candidateID = updatedData?.candidateid;
        dispatch(getcandidateSubmissionsAction(userid, candidateID, 0, 20));

        dispatch(openRightPanelAction(false));

        //dispatch(selectedSubmissionAction())
      }
      dispatch({
        type: types.UPDATE_SUBMISSIONS_ACTION,
        payload: res?.data,
      });
    } catch (err) {
      dispatch({
        type: types.UPDATE_SUBMISSIONS_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const sendJobToCandidateAction = (
  sendJobDetails,
  updatedData,
  userId,
  candidateId,
  jobId
) => {
  let apiUrl = url("send_job_to_candidate");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, sendJobDetails);
      let sendJob;
      if (res?.data?.affectedRows > 0) {
        dispatch(
          updateSubmissionsAction(updatedData, userId, candidateId, jobId)
        );
        sendJob = res;
      }
      dispatch({
        type: types.SEND_JOB_TO_CANDIDATE_ACTION,
        payload: sendJob,
      });
      return res;
    } catch (err) {
      dispatch({
        type: types.SEND_JOB_TO_CANDIDATE_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const sendProfileToVendor = (
  sendProfileDetails,
  updatedData,
  userId,
  candidateId,
  jobId,
  resume_id
) => {
  let apiUrl = url("send_profile_to_vendor");
  return async (dispatch) => {
    try {
      // dispatch(
      //   updateSubmissionsAction(updatedData, userId, candidateId, jobId)
      // );

      if (resume_id) {
        var profileDetails = {
          ...sendProfileDetails,
          resumeid: resume_id,
        };

        const res = await post(apiUrl, profileDetails);

        let sendJob;
        if (res?.data?.affectedRows > 0) {
          sendJob = res?.data;
          dispatch(
            updateSubmissionsAction(updatedData, userId, candidateId, jobId)
          );
        }
        dispatch({
          type: types.SEND_PROFILE_TO_VENDOR,
          payload: sendJob,
        });
        let msg = "Profile Sent Successfully";

        dispatch(alertSnackBarAction(msg, "success"));
      } else {
        throw new Error("Resume not selected");
      }
    } catch (err) {
      let msg = err?.message ? err.message : err ? err : "Something went wrong";
      dispatch(alertSnackBarAction(msg, "error"));

      dispatch({
        type: types.SEND_PROFILE_TO_VENDOR_FAIL,
        payload: err?.message,
      });
    }
  };
};
export const rateConfirmationAction = (
  rate,
  updatedData,
  userId,
  candidateId,
  jobId
) => {
  let apiUrl = url("rate_confirmation");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, rate);
      let rateDetails;
      if (res?.data?.submission?.affectedRows > 0) {
        rateDetails = res?.data;
        dispatch(
          updateSubmissionsAction(updatedData, userId, candidateId, jobId)
        );
      }
      dispatch({
        type: types.RATE_CONFIRMATION_ACTION,
        payload: rateDetails,
      });
    } catch (err) {
      dispatch({
        type: types.RATE_CONFIRMATION_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const selectedSubmissionAction = (sub) => (dispatch) => {
  dispatch({
    type: types.SELECTED_SUBMISSION_ACTION,
    payload: sub,
  });
};

export const interviewScheduleAction = (
  interviewDetails,
  updatedData,
  userId,
  candidateId,
  jobId
) => {
  let apiUrl = url("interview_schedule");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, interviewDetails);
      let Details;
      if (res?.data?.affectedRows > 0) {
        Details = res?.data;
        dispatch(
          updateSubmissionsAction(updatedData, userId, candidateId, jobId)
        );
      }
      dispatch({
        type: types.INTERVIEW_SCHEDULE_ACTION,
        payload: Details,
      });
      return res;
    } catch (err) {
      dispatch({
        type: types.INTERVIEW_SCHEDULE_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};
export const updateInterviewScheduleAction = (
  interviewDetails,
  updatedData
) => {
  let apiUrl = url("update_interview");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, interviewDetails);
      let Details;
      // await dispatch(updateSubmissionsAction(updatedData));

      if (res?.data?.affectedRows > 0) {
        Details = res?.data;
        await dispatch(updateSubmissionsAction(updatedData));
      }
      dispatch({
        type: types.UPDATE_INTERVIEW_SCHEDULE_ACTION,
        payload: Details,
      });
    } catch (err) {
      dispatch({
        type: types.UPDATE_INTERVIEW_SCHEDULE_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};
export const uploadDocumentsAction = (documentData) => {
  let apiUrl = url("upload_documents");
  return async (dispatch) => {
    try {
      let res = await post(apiUrl, documentData);
      if (res?.data) {
        // alert("Document Uploaded Successfully");
      }
      dispatch({
        type: types.UPLOAD_DOCUMENTS_ACTION,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: types.UPLOAD_DOCUMENTS_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};
export const addCandidateAction = (addDetails, userId, file) => {
  let apiUrl = url("add_candidate");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, addDetails);
      let result;
      if (res?.data?.userResult?.insertId) {
        //alert("Candidate Added Successfully");
        result = "created";
        dispatch(
          alertSnackBarAction("Candidate Added Successfully", "success")
        );
        await dispatch(resetCandidatesAction());
        await dispatch(getActiveCandidatesAction(userId, 1, 20));
        await dispatch(openRightPanelAction(false));
      } else if (res?.data?.success == 0) {
        //alert(res?.data?.message);
        dispatch(alertSnackBarAction(res?.data?.message, "warning"));
        await dispatch(getActiveCandidatesAction(userId, 1, 20));
      } else {
        // alert("Something Went Wrong")
      }
      dispatch({
        type: types.ADD_CANDIDATE_ACTION,
        payload: res,
        result,
      });
      return res;
    } catch (err) {
      dispatch({
        type: types.ADD_CANDIDATE_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const updateCandidateAction = (candidateID, updatedDetails, userId) => {
  let apiUrl = url("update_candidate")(candidateID);
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, updatedDetails);
      if (res?.data?.affectedRows > 0) {
        await dispatch(resetCandidatesAction());
        // alert("Candidate Details Updated Successfully");
        await dispatch(getActiveCandidatesAction(userId, 1, 20));
      }
      dispatch({
        type: types.UPDATE_CANDIDATE_ACTION,
        payload: res?.data,
      });
    } catch (err) {
      dispatch({
        type: types.UPDATE_CANDIDATE_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const getCountriesAction = () => {
  let apiUrl = url("get_countries");
  return async (dispatch) => {
    try {
      let res = await get(apiUrl);
      let countries;
      if (res?.data) {
        countries = res?.data?.types;
      }
      dispatch({
        type: types.GET_COUNTRIES_ACTION,
        payload: countries,
      });
    } catch (err) {
      dispatch({
        type: types.GET_COUNTRIES_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const getStatesAction = (countryid) => {
  let apiUrl = url("get_states")(countryid);
  return async (dispatch) => {
    try {
      let res = await get(apiUrl);
      let states;
      if (res?.data) {
        states = res?.data?.types;
      }
      dispatch({
        type: types.GET_STATES_ACTION,
        payload: states,
      });
    } catch (err) {
      dispatch({
        type: types.GET_STATES_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const getCitiesAction = (stateID) => {
  let apiUrl = url("get_cities")(stateID);
  return async (dispatch) => {
    try {
      let res = await get(apiUrl);
      let cities;
      if (res?.data) {
        cities = res?.data?.types;
      }
      dispatch({
        type: types.GET_CITIES_ACTION,
        payload: cities,
      });
    } catch (err) {
      dispatch({
        type: types.GET_CITIES_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const getJobTypesAction = () => {
  let apiUrl = url("get_jobtypes");
  return async (dispatch) => {
    try {
      let res = await get(apiUrl);
      let jobTypes;
      if (res?.data) {
        jobTypes = res?.data?.types;
      }
      dispatch({
        type: types.GET_JOBTYPES_ACTION,
        payload: jobTypes,
      });
    } catch (err) {
      dispatch({
        type: types.GET_JOBTYPES_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const getZipcodesAction = (cityID) => {
  //console.log("getZipcodesAction called with cityID:", cityID);
  return async (dispatch) => {
    try {
      const response = await fetch(`${Key.domain_jnp}/commonAPIs/get_zipcodes_By_cityId`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          city_id: cityID,
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const res = await response.json();
      //console.log("Zipcodes API response:", res);

      let zipcodes;
      if (res?.data) {
        zipcodes = res.data;
        //console.log("Extracted zipcodes:", zipcodes);
      }

      dispatch({
        type: types.GET_ZIPCODES_ACTION,
        payload: zipcodes,
      });
    } catch (err) {
      console.error("Error fetching zipcodes:", err);
      dispatch({
        type: types.GET_ZIPCODES_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};
export const shareProfileAction = (shareData) => {
  let apiUrl = url("share_profile");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, shareData);

      let response;
      if (res?.data?.affectedRows > 0) {
        response = res?.data;
      }
      dispatch({
        type: types.SHARE_PROFILE_ACTION,
        payload: response,
      });
    } catch (err) {
      dispatch({
        type: types.SHARE_PROFILE_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

// export const vmailSignInAction = (email, password) => {
//   let apiUrl = url("Vmail_signin");
//   let data = {
//     email: email,
//     password: password,
//   }
//   return async (dispatch) => {
//     try {
//       const res = await post(apiUrl, data);
//      // const { token, message } = res.data;
//       if(res.success === true){
//         let token = res.token
//         sessionStorage.setItem("MailFlow", `Bearer ${token}`);
//       }
//       dispatch({
//         type: types.VMAIL_SIGNIN_ACTION,
//         payload: res
//       });
//     } catch (err) {
//       dispatch({
//         type: types.VMAIL_SIGNIN_ACTION_FAIL,
//         payload:  "Invalid username or password"
//       });
//     }
//   };
// };

// export const vmailSignIUpAction = (data) => {
//   let apiUrl = url("Vmail_signup");
//   return async (dispatch) => {
//     try {
//       const res = await post(apiUrl, data);
//      // const { token, message } = res.data;
//       if(res.status === 200){
//       }
//       dispatch({
//         type: types.VMAIL_SIGNUP_ACTION,
//         payload: res
//       });
//     } catch (err) {
//       dispatch({
//         type: types.VMAIL_SIGNUP_ACTION_FAIL,
//         payload:  "Invalid username or password"
//       });
//     }
//   };
// };
export const vmailTokenAction = (token) => (dispatch) => {
  //console.log("vmailTokenAction called with:", token);
  dispatch({
    type: types.VMAIL_TOKEN_ACTION,
    payload: token,
  });
};
export const vmailSignInAction = (email, password, user) => {
  return async (dispatch) => {
    try {
      const response = await fetch(`${Key.domain_vmail}/api/v1/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const res = await response.json();

      if (res.success === true) {
        const token = res.token;

        dispatch(vmailTokenAction(token));
        localStorage.setItem("MailFlow", `Bearer ${token}`);

        dispatch({
          type: types.VMAIL_SIGNIN_ACTION,
          payload: res,
        });

      } else {
        console.log("Login failed → trying signup");
        await dispatch(vmailSignIUpAction(user));
      }

    } catch (err) {
      console.error("Login error:", err);

      dispatch({
        type: types.VMAIL_SIGNIN_ACTION_FAIL,
        payload: "Login failed",
      });
      await dispatch(vmailSignIUpAction(user));
    }
  };
};

export const vmailSignIUpAction = (user) => {
  const apiUrl = url("Vmail_signup");
  return async (dispatch) => {
    try {
      const response = await fetch(`${Key.domain_vmail}/api/v1/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstName: user?.full_name,
          lastName: user?.full_name,
          email: user?.username,
          password: "Welcome@123",
        }),
      });
      const res = await response.json();
      if (response.status === 200) {
        dispatch({
          type: types.VMAIL_SIGNUP_ACTION,
          payload: res,
        });
        await dispatch(vmailSignInAction(user?.username, "Welcome@123"));
      }
    } catch (err) {
      dispatch({
        type: types.VMAIL_SIGNUP_ACTION_FAIL,
        payload: "Invalid username or password",
      });
    }
  };
};

export const getActiveCandidatesAction = (userid, page, limit, searchText) => {
  let apiUrl = url("active_candidates")(userid, page, limit, searchText);

  return async (dispatch) => {
    try {
      if (parseInt(page) === 1) {
        dispatch({
          type: types.GET_ACTIVE_CANDIDATES_LOADING_ACTION,
        });
      }
      const res = await get(apiUrl);
      let candidates = [];

      if (res?.data) {
        candidates = res?.data?.candidates || [];
      }

      dispatch({
        type: types.GET_ACTIVE_CANDIDATES_ACTION,
        payload: candidates,
        pageNo: page,
      });
      return res;
    } catch (err) {
      dispatch({
        type: types.GET_ACTIVE_CANDIDATES_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const getInActiveCandidatesAction = (userid, page, limit) => {
  let apiUrl = url("Inactive_candidates")(userid, page, limit);

  return async (dispatch) => {
    try {
      const res = await get(apiUrl);
      let candidates;

      if (res?.data) {
        candidates = res?.data?.candidates;
      }

      if (candidates.length > 0) {
        dispatch({
          type: types.GET_INACTIVE_CANDIDATES_ACTION,
          payload: candidates,
        });
      }
      return res;
    } catch (err) {
      dispatch({
        type: types.GET_INACTIVE_CANDIDATES_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

// export const updateCandidateStatusAction1 = (candidateid , candidate_status) => {
//   let apiUrl = url("update_candidate_status")(candidateid , candidate_status);

//   return async (dispatch) => {
//     try {
//       const res = await get(apiUrl);
//       let candidates;

//       if (res?.data) {
//         candidates = res?.data?.candidates;
//       }

//       if (candidates.length > 0) {
//         dispatch({
//           type: types.GET_INACTIVE_CANDIDATES_ACTION,
//           payload: candidates,
//         });
//       }
//       return res;
//     } catch (err) {
//       dispatch({
//         type: types.GET_INACTIVE_CANDIDATES_ACTION_FAIL,
//         payload: err,
//       });
//     }
//   };
// };

export const updateCandidateStatusAction = (updatedDetails, userId) => {
  let apiUrl = url("update_candidate_status");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, updatedDetails);
      //console.log("data---", res.data)
      // if (res?.data?.results?.affectedRows > 0) {
      //   await dispatch(resetCandidatesAction());

      //   if (updatedDetails?.candidate_status === 0) {
      //     await dispatch(getActiveCandidatesAction(userId, 1, 20));
      //   } else {
      //     await dispatch(getInActiveCandidatesAction(userId, 1, 20));
      //   }
      // }
      dispatch({
        type: types.UPDATE_CANDIDATE_STATUS_ACTION,
        payload: res?.data,
      });
      try {
        await dispatch(resetCandidatesAction());
        if (updatedDetails?.candidate_status === 0) {
          await dispatch(getActiveCandidatesAction(userId, 1, 200));
        } else {
          await dispatch(getInActiveCandidatesAction(userId, 1, 200));
        }
      } catch (err) {
        console.error("Error in dispatches after update:", err);
      }
    } catch (err) {
      dispatch({
        type: types.UPDATE_CANDIDATE_STATUS_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const getSourcesAction = (data) => {
  let apiUrl = url("get_sources");
  return async (dispatch) => {
    try {
      dispatch({
        type: types.GET_SOURCES_LOADING_ACTION,
      });
      //  const res = await get(apiUrl);
      const today = new Date();
      const last7Days = new Date(today);
      last7Days.setDate(today.getDate() - 7);
      const formattedDate = last7Days.toISOString().split("T")[0];
      const formattedToday = today.toISOString().split("T")[0];
      const response = await fetch(
        `${Key.domain}/job/sourceNamesFromTo/${data?.page}/${data?.limit}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            days: data?.days,
            fromDate: formattedDate + "T00:00:00Z",
            toDate: formattedToday + "T23:59:59Z",
          }),
        }
      );
      const res = await response.json();
      if (response.status === 200) {
        dispatch({
          type: types.GET_SOURCES_ACTION,
          payload: res?.data,
        });
        return res?.data; // Return the data to be used in fetchData
      } else {
        throw new Error("Failed to fetch sources");
      }
    } catch (err) {
      dispatch({
        type: types.GET_SOURCES_ACTION_FAIL,
        payload: err,
      });
    }
  };
};


export const selectedSourceAction = (source) => (dispatch) => {
  dispatch({
    type: types.SELECTED_SOURCE_ACTION,
    payload: source,
  });
};

export const updateInterestedJobAction = (updatedDetails) => {
  let apiUrl = url("interestedJob");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, updatedDetails);
      if (
        res?.data?.results?.affectedRows > 0 ||
        res?.data?.results?.insertId
      ) {
        // await dispatch(getInterestedJobAction(updatedDetails))
      }
      dispatch({
        type: types.JOB_INTERESTED_STATUS_ACTION,
        payload: res?.data,
      });
      return res?.data;
    } catch (err) {
      dispatch({
        type: types.JOB_INTERESTED_STATUS_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const getInterestedJobAction = (updatedDetails) => {
  let apiUrl = url("check_interested_job");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, updatedDetails);
      if (res?.success === 1) {
      }
      dispatch({
        type: types.GET_INTERESTED_JOB_ACTION,
        payload: res?.data,
      });
      return res.data;
    } catch (err) {
      dispatch({
        type: types.GET_INTERESTED_JOB_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const CandidateLoginAction = (userCredentials) => {
  let apiUrl = url("candidate_login");

  return async (dispatch) => {
    try {
      const res = await post(apiUrl, userCredentials);
      let user;

      if (res?.success === 1) {
        user = res?.data?.user;
        dispatch({
          type: types.CANDIDATE_LOGIN_ACTION,
          payload: user,
        });
      } else {
        let msg = res?.data;
        dispatch(alertSnackBarAction(msg, "warning"));
      }
      return res?.data;
    } catch (err) {
      dispatch({
        type: types.CANDIDATE_LOGIN_ACTION_FAIL,
        payload: err,
      });
      return "login_failed";
    }
  };
};

export const updatePrimaryResumeAction = (updatedData) => {
  let apiUrl = url("update_primary_resume");
  return async (dispatch) => {
    try {
      let res = await post(apiUrl, updatedData);
      if (res?.data?.affectedRows > 0) {
      }
      dispatch({
        type: types.UPDATE_PRIMARY_RESUME_ACTION,
        payload: res?.data,
      });
      return res;
    } catch (err) {
      dispatch({
        type: types.UPDATE_PRIMARY_RESUME_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const getPrimaryResumeDetailsAction = (updateData) => {
  let apiUrl = url("get_primary_resume");
  return async (dispatch) => {
    dispatch({ type: types.GET_PRIMARY_RESUME_DETAILS_LOADING_ACTION });
    try {
      const res = await post(apiUrl, updateData);
      let primaryResumeDetails;
      if (res?.success === 1) {
        primaryResumeDetails = res?.data?.[0];
      }
      dispatch({
        type: types.GET_PRIMARY_RESUME_DETAILS_ACTION,
        payload: primaryResumeDetails,
      });
      return res;
    } catch (err) {
      dispatch({
        type: types.GET_PRIMARY_RESUME_DETAILS_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const getRecruiterInterestedCandidatesAction = (updateData) => {
  let apiUrl = url("get_recruiters_interested_job_candidates");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, updateData);
      let interestedCandidates;
      if (res?.data) {
        interestedCandidates = res?.data?.results;
      }
      dispatch({
        type: types.GET_RECRUITER_INTERESTED_CANDIDATES_ACTION,
        payload: interestedCandidates,
      });
      return res?.data;
    } catch (err) {
      dispatch({
        type: types.GET_RECRUITER_INTERESTED_CANDIDATES_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const creteNotificationAction = (NotificationDetails) => {
  let apiUrl = url("create_notification");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, NotificationDetails);
      if (res?.success == 1) {
      }
      dispatch({
        type: types.CREATE_NOTIFICATION_ACTION,
        payload: res?.data,
      });
    } catch (err) {
      dispatch({
        type: types.CREATE_NOTIFICATION_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const getMyRecruitersAction = (RecruiterData) => {
  let apiUrl = url("get_my_recruiters");

  return async (dispatch) => {
    try {
      dispatch({ type: types.GET_MY_ACTIVE_RECRUITERS_LOADING });
      const res = await post(apiUrl, RecruiterData);
      let myRecruiters = [];
      if (res?.success == 1) {
        myRecruiters = res?.data;
      }

      if (myRecruiters?.length > 0) {
        dispatch(selectedRecruiterAction(myRecruiters[0]));
      }
      dispatch({
        type: types.GET_MY_ACTIVE_RECRUITERS_ACTION,
        payload: myRecruiters,
      });
      return res;
    } catch (err) {
      dispatch({
        type: types.GET_MY_ACTIVE_RECRUITERS_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const addOrEditRecruiterAction = (recruiterFormData, RecruiterData) => {
  let apiUrl = url("add_or_edit_recruiter");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, recruiterFormData);
      if (res?.data?.userResult?.insertId || res?.data?.userResult?.id) {
        await dispatch(
          alertSnackBarAction("Recruiter added successfully", "success")
        );
        await dispatch(getMyRecruitersAction(RecruiterData));
      } else if (res?.data?.results?.affectedRows > 0) {
        await dispatch(getMyRecruitersAction(RecruiterData));
        dispatch(alertSnackBarAction(res?.data?.message, "success"));
      } else {
        dispatch(alertSnackBarAction(res?.data?.message, "warning"));
      }
      dispatch({
        type: types.ADD_OR_EDIT_RECRUITER_ACTION,
        payload: res?.data,
      });
    } catch (err) {
      dispatch({
        type: types.ADD_OR_EDIT_RECRUITER_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const getCandidateResumeListAction = (candidateData) => {
  let apiUrl = url("get_candidate_resume_list");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, candidateData);
      let candidateResumeList;
      if (res?.success === 1) {
        candidateResumeList = res?.data;
      }
      dispatch({
        type: types.GET_CANDIDATES_RESUMES_LIST_ACTION,
        payload: candidateResumeList,
      });
      return res;
    } catch (err) {
      dispatch({
        type: types.GET_CANDIDATES_RESUMES_LIST_ACTION_FAIL,
        payload: err,
      });
    }
  };
};


export const getCandidateResumeListActionTemp = (candidateData) => {
  let apiUrl = url("get_candidate_resume_list_temp");
  return async (dispatch) => {
    dispatch({ type: types.GET_CANDIDATES_RESUMES_LIST_ACTION_TEMP_LOADING_ACTION });
    try {
      const res = await post(apiUrl, candidateData);
      let candidateResumeList;
      if (res?.success === 1) {
        candidateResumeList = res?.data;
      }
      dispatch({
        type: types.GET_CANDIDATES_RESUMES_LIST_ACTION_TEMP,
        payload: candidateResumeList,
      });
      return res;
    } catch (err) {
      dispatch({
        type: types.GET_CANDIDATES_RESUMES_LIST_ACTION_FAIL,
        payload: err,
      });
    }
  };
};


export const candidateSelectedResumeAction = (resume) => (dispatch) => {
  dispatch({
    type: types.CANDIDATE_SELECTED_RESUME_ACTION,
    payload: resume,
  });
};

export const assignCandidateToRecruiterAction = (
  allocatedCandidatesData,
  user_id,
  recruiter_id
) => {
  let apiUrl = url("assign_candidate_to_recruiter");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, allocatedCandidatesData);
      if (res?.data) {
        // dispatch(getMyRecruitersAction({ company_admin_id: user_id }));
        const data = {
          recruiter_id: recruiter_id,
        };
        dispatch(getAssignedCandidatesAction(data));
      }
    } catch (err) {
      dispatch({
        type: types.ASSIGN_CANDIDATES_TO_RECRUITERS_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const selectedRecruiterAction = (recruiter) => (dispatch) => {
  const recruiter_data = {
    recruiter_id: recruiter?.recruiter_uid,
  };
  dispatch(getAssignedCandidatesAction(recruiter_data));
  dispatch({
    type: types.SELECTED_RECRUITER_ACTION,
    payload: recruiter,
  });
};

export const getAssignedCandidatesAction = (recruiterData) => {
  let apiUrl = url("get_assigned_candidates");
  return async (dispatch) => {
    try {
      if (!recruiterData?.recruiter_id) {
        dispatch({
          type: types.GET_ASSIGNED_CANDIDATES_ACTION,
          payload: [],
        });
        return;
      }

      const res = await post(apiUrl, recruiterData);
      let assignedCandidates = [];
      if (res?.data) {
        assignedCandidates = Array.isArray(res.data) ? res.data : [];
      }
      dispatch({
        type: types.GET_ASSIGNED_CANDIDATES_ACTION,
        payload: assignedCandidates,
      });
    } catch (err) {
      console.error("Error fetching assigned candidates:", err);
      dispatch({
        type: types.GET_ASSIGNED_CANDIDATES_ACTION_FAIL,
        payload: [],
      });
    }
  };
};

export const updateAdminAccessAction = (recruiterData) => {
  let apiUrl = url("admin_access");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, recruiterData);
      if (res?.success === 1) {
      }
      dispatch({
        type: types.UPDATE_ADMIN_ACCESS_ACTION,
        updateAdminAccess: res?.data,
      });
      // const data = { company_admin_id: recruiterData?.user_id, }
      // dispatch(getMyRecruitersAction(data));
      return res;
    } catch (err) {
      dispatch({
        type: types.UPDATE_ADMIN_ACCESS_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const removeAssignedCandidateAction = (recruiterData, assignedData) => {
  let apiUrl = url("remove_assigned_candidate");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, recruiterData);
      if (res?.data?.affectedRows > 0) {
        dispatch(
          alertSnackBarAction("Candidate Removed Successfully", "success")
        );
        dispatch(getAssignedCandidatesAction(assignedData));
      }
      dispatch({
        type: types.REMOVE_ASSIGNED_CANDIDATES_ACTION,
        payload: res,
      });
    } catch (err) {
      dispatch({
        type: types.REMOVE_ASSIGNED_CANDIDATES_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const updateRecruiterStatusAction = (updatedData, recruiterData, listSource = "active") => {
  let apiUrl = url("update_recruiter_status");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, updatedData);
      if (res?.data?.affectedRows > 0) {
        if (updatedData?.status === 0) {
          dispatch(
            alertSnackBarAction("Recruiter Inactivated Successfully", "success")
          );
        } else {
          dispatch(
            alertSnackBarAction("Recruiter Activated Successfully", "success")
          );
        }
        if (listSource === "inactive") {
          const response = await dispatch(
            getMyInactiveRecruitersAction(recruiterData)
          );
          return response;
        } else {
          const response = await dispatch(
            getMyRecruitersAction(recruiterData)
          );
          return response;
        }
      } else {
        dispatch(alertSnackBarAction("Recruiter Status Update Failed", "error"));
      }
      dispatch({
        type: types.UPDATE_RECRUITER_STATUS_ACTION,
      });
    } catch (err) {
      dispatch({
        type: types.UPDATE_RECRUITER_STATUS_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const getMyInactiveRecruitersAction = (RecruiterData) => {
  let apiUrl = url("get_my_Inactive_recruiters");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, RecruiterData);
      let myRecruiters;
      if (res?.success == 1) {
        myRecruiters = res?.data;
      }

      if (myRecruiters?.length > 0) {
        const recruiter_data = myRecruiters?.[0];
        dispatch(selectedRecruiterAction(recruiter_data));
      }
      dispatch({
        type: types.GET_INACTIVE_RECRUITERS_ACTION,
        payload: myRecruiters,
      });
      return res;
    } catch (err) {
      dispatch({
        type: types.GET_INACTIVE_RECRUITERS_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const deleteResumeAction = (resumeData, candidateData) => {
  let apiUrl = url("delete_resume");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, resumeData);
      if (res?.data?.results?.affectedRows > 0) {
        await dispatch(
          alertSnackBarAction("Resume deleted successfully", "success")
        );
        await dispatch(getCandidateResumeListAction(candidateData));
      } else {
        dispatch(alertSnackBarAction("Resume deletion failed", "error"));
      }
      dispatch({
        type: types.DELETE_RESUME_ACTION,
      });
    } catch (err) {
      dispatch({
        type: types.DELETE_RESUME_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const getCandidatesRoleBasedJobReportsAction = (adminId) => {
  let apiUrl = url("get_role_Jobs_count_reports");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, adminId);
      dispatch({
        type: types.CANDIDATE_ROLE_BASED_JOB_REPORTS,
        payload: res?.data,
      });
    } catch (err) {
      dispatch({
        type: types.CANDIDATE_ROLE_BASED_JOB_REPORTS,
        payload: err,
      });
    }
  };
};

export const getInterestedJobListAction = (candidateId) => {
  let apiUrl = url("get_interested_joblist");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, candidateId);
      dispatch({
        type: types.GET_INTERESTED_JOB_LIST_ACTION,
        payload: res?.data?.results?.[0],
      });
    } catch (err) {
      dispatch({
        type: types.GET_INTERESTED_JOB_LIST_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const getJobsCountAction = () => {
  let apiUrl = url("get_jobs_count");
  return async (dispatch) => {
    try {
      const res = await get(apiUrl);
      dispatch({
        type: types.GET_JOBS_COUNT_ACTION,
        payload: res?.data,
      });
    } catch (err) {
      dispatch({
        type: types.GET_JOBS_COUNT_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const getCandidateJobdetailsAction = (candidateId) => {
  let apiUrl = url("candidate_jobDetails")(candidateId);
  return async (dispatch) => {
    try {
      const res = await get(apiUrl);
      dispatch({
        type: types.GET_CANDIDATE_JOBDETAILS_ACTION,
        payload: res?.data?.jobs,
      });
    } catch (err) {
      dispatch({
        type: types.GET_CANDIDATE_JOBDETAILS_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const getJobtypeFilteredIDS = (body) => {
  return async (dispatch) => {
    try {
      let apiUrl = url("jobtype_jobids");
      //console.log(apiUrl);
      const res = await post(apiUrl, body);
      dispatch({
        type: types.GET_JOBTYPE_FILTERED_IDS_ACTION,
        payload: res?.data,
      });
    } catch (err) {
      dispatch({
        type: types.GET_JOBTYPE_FILTERED_IDS_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const removeJobtypeFilter = () => {
  return async (dispatch) => {
    dispatch({
      type: types.REMOVE_JOBTYPE_FILTER_ACTION,
    });
  };
};

export const getJobsFromDb = (body) => {
  return async (dispatch) => {
    try {
      //console.log(body);
      let apiUrl = url("getjobs_db");
      const res = await post(apiUrl, body);
      dispatch({
        type: types.GET_JOBS_FROM_DB_ACTION,
        payload: res?.data?.results,
      });
    } catch (err) {
      dispatch({
        type: types.GET_JOBS_FROM_DB_FAIL_ACTION,
        payload: err,
      });
    }
  };
};

export const recruitersActivity = (user) => {
  let apiUrl = url("get_users_last_seen");

  return async (dispatch) => {
    try {
      const data = {
        user_id: user.id,
        session_token: user.session_token,
      };
      let users_activity;
      const res = await post(apiUrl, data);

      if (res?.data) {
        users_activity = res?.data && res?.data.length > 0 && res?.data;
      }

      dispatch({
        type: types.RECRUITERS_ACTIVITY_ACTION,
        payload: users_activity,
      });
    } catch (err) {
      dispatch({
        type: types.RECRUITERS_ACTIVITY_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const getCompanyPackageDataAction = (data) => {
  let apiUrl = url("get_company_package_data");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, data);
      dispatch({
        type: types.GET_COMPANY_PACKAGE_DATA_ACTION,
        payload: res?.data,
      });
      return res;
    } catch (err) {
      dispatch({
        type: types.GET_COMPANY_PACKAGE_DATA_ACTION_FAIL,
        payload: err,
      });
      return err;
    }
  };
};

export const updatePackageAlertLogAction = (data) => {
  let apiUrl = url("update_package_alert_log");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, data);
      dispatch({
        type: types.UPDATE_PACKAGE_ALERT_LOG_ACTION,
        payload: res?.data,
      });
      return res;
    } catch (err) {
      dispatch({
        type: types.UPDATE_PACKAGE_ALERT_LOG_ACTION_FAIL,
        payload: err,
      });
      return err;
    }
  };
};

